<template>
  <Button v-if="storeUrl" :href="loginUrl" tag="a" width="full" :theme="theme">
    Continue with Google
  </Button>
</template>

<script>
import Button from "@/components/ButtonV3.vue";
export default {
  name: "GoogleSignOn",
  components: {
    Button,
  },
  props: {
    theme: {
      type: String,
      default: "primary",
    },
    returnUrl: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      storeUrl: process.env.SHOPIFY_SSO_STORE_URL || null,
    };
  },
  computed: {
    loginUrl() {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });

      const returnUrl =
        this.returnUrl || params["checkout_url"] || params["return_url"];

      let redirectUrl = "/account/login";
      if (returnUrl) {
        redirectUrl = "/account/login?return_url=" + returnUrl;
      }

      const encodedRedirectUrl = encodeURI(redirectUrl);

      return `https://login.ratandboa.com/moas/broker/login/shopify/${this.storeUrl}/account?idpname=google_oauth&redirect_endpoint=${encodedRedirectUrl}`;
    },
  },
};
</script>
